import { FETCH_INVOICES_RESULT } from "../actions/index";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_INVOICES_RESULT:
      const payer = action.payload[0].payer;
      const invoices = action.payload[1].invoices;
      const installments = action.payload[2].installments;

      return { ...state, payer, invoices, installments };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Invoices.js